import axios from 'axios'
import {host} from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    informacionGeneralInstalacionCliente: [],
    informacionGeneralInstalacionClienteById:[],
    instalacionesCliente:[],
    instalacionesClienteById:[],
    responsablesInstalacion:[],
    responsablesInstalacionById:[]
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_INFORMACION_GENERAL_INSTALACION_CLIENTE= 'GET_ALL_INFORMACION_GENERAL_INSTALACION_CLIENTE'
const GET_ALL_INFORMACION_GENERAL_INSTALACION_CLIENTE_BY_CLIENTE= 'GET_ALL_INFORMACION_GENERAL_INSTALACION_CLIENTE_BY_CLIENTE'
const GET_ALL_INSTALACIONES_CLIENTE = 'GET_ALL_INSTALACIONES_CLIENTE'
const GET_ALL_INSTALACIONES_CLIENTE_BY_ID = 'GET_ALL_INSTALACIONES_CLIENTE_BY_ID'
const GET_ALL_RESPONSABLES_INSTALACION = 'GET_ALL_RESPONSABLES_INSTALACION'
const GET_ALL_RESPONSABLES_INSTALACION_BY_INSTALACION = 'GET_ALL_RESPONSABLES_INSTALACION_BY_INSTALACION'
const DICTAMINAR_INSTALACION = 'DICTAMINAR_INSTALACION'
//*******************************************************************************************************************


//MÉTODOS 
export const obtenerAllGeneralInstalacionCliente = createAsyncThunk(
    GET_ALL_INFORMACION_GENERAL_INSTALACION_CLIENTE,
    async () => {
        try {
            const fullUrl = host + `InformacionValida/obtenerAllInformacionGeneralInstalacionCliente`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerAllGeneralInstalacionClienteById = createAsyncThunk(
    GET_ALL_INFORMACION_GENERAL_INSTALACION_CLIENTE_BY_CLIENTE,
    async (id) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerInformacionGeneralInstalacionCliente/${id}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerAllInstalacionesCliente = createAsyncThunk(
    GET_ALL_INSTALACIONES_CLIENTE,
    async () => {
        try {
            const fullUrl = host + `InformacionValida/obtenerAllInstalacionesCliente`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerAllInstalacionesClienteById = createAsyncThunk(
    GET_ALL_INSTALACIONES_CLIENTE_BY_ID,
    async (id) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerInstalacionesCliente/${id}`
            const result = await axios.get(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerAllResponsablesInstalacion = createAsyncThunk(
    GET_ALL_RESPONSABLES_INSTALACION,
    async () => {
        try {
            const fullUrl = host + `InformacionValida/obtenerAllResponsablesDeInstalacionCliente`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerAllResponsablesInstalacionByInstalacion = createAsyncThunk(
    GET_ALL_RESPONSABLES_INSTALACION_BY_INSTALACION,
    async (id) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerResponsablesDeInstalacionCliente/${id}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarDictaminar = createAsyncThunk(
    DICTAMINAR_INSTALACION,
    async (data) => {
        try {
            const fullUrl = host + `Instalacion/dictaminar`
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosInstalacionSlice = createSlice({


    /*informacionGeneralInstalacionCliente: [],
    informacionGeneralInstalacionClienteById:[],
    instalacionesCliente:[],
    instalacionesClienteById:[],
    responsablesInstalacion:[],
    responsablesInstalacionById:[]
    */


    name: 'metodosInstalacionSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
      
        [obtenerAllGeneralInstalacionCliente.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.informacionGeneralInstalacionCliente = payload.data.data
        },
        [obtenerAllGeneralInstalacionClienteById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.informacionGeneralInstalacionClienteById = payload.data.data
        },
        [obtenerAllInstalacionesCliente.fulfilled]: (state, { payload }) => {
            state.instalacionesCliente = payload.data.data
        },
        [obtenerAllInstalacionesClienteById.fulfilled]: (state, { payload }) => {
            state.instalacionesClienteById = payload.data.data
        },
        [obtenerAllResponsablesInstalacion.fulfilled]: (state, { payload }) => {
            state.responsablesInstalacion = payload.data.data
        },
        [obtenerAllResponsablesInstalacionByInstalacion.fulfilled]: (state, { payload }) => {
            state.responsablesInstalacionById = payload.data.data
        },
    },

})


export const {} = metodosInstalacionSlice.actions
export const InstalacionReducer = metodosInstalacionSlice.reducer